/**
 * Entry point. Mounts <App /> inside a QueryClientProvider, imports the
 * single global stylesheet, and registers the root.
 */

import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

import { registerServiceWorker } from "@/lib/serviceWorker";
import { TenantProvider } from "@/lib/tenant";

import { App } from "./App";

import "./styles/app.css";

registerServiceWorker();

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
      staleTime: 30_000,
    },
  },
});

const container = document.getElementById("root");
if (!container) {
  throw new Error("Root element #root not found in index.html");
}

createRoot(container).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <TenantProvider>
        <App />
      </TenantProvider>
    </QueryClientProvider>
  </StrictMode>,
);
